import { render, staticRenderFns } from "./icyBack.vue?vue&type=template&id=b5d8730a&scoped=true&"
import script from "./icyBack.vue?vue&type=script&lang=js&"
export * from "./icyBack.vue?vue&type=script&lang=js&"
import style0 from "./icyBack.vue?vue&type=style&index=0&id=b5d8730a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d8730a",
  null
  
)

export default component.exports